import React from "react";
import { Container } from "react-bootstrap";
import parse from "html-react-parser";
import "./index.css";

const MarketStats = ({ data }) => {
  if (!data?.stats?.length) return null;

  return (
    <section className="market-stats-section section-spacing">
      {/* Desktop stats - full width */}
      <div className="market-stats-bar market-stats-desktop">
        {data.stats.map((stat, i) => (
          <div className="market-stat" key={i}>
            <span className="market-stat-value">{parse(stat.value)}</span>
            <span className="market-stat-label">{parse(stat.label)}</span>
          </div>
        ))}
      </div>

      {/* Mobile scrolling stats */}
      <Container>
        <div className="market-stats-mobile">
          <div className="market-stats-track">
            {[...data.stats, ...data.stats].map((stat, i) => (
              <div className="market-stat" key={i}>
                <span className="market-stat-value">{parse(stat.value)}</span>
                <span className="market-stat-label">{parse(stat.label)}</span>
              </div>
            ))}
          </div>
        </div>
      </Container>
    </section>
  );
};

export default MarketStats;
